import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickHaulers } from '@ordersnproducts/modules/one-click-order/selectors/one-click-haulers.selector';

@Injectable()
export class OneClickHaulersLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickHaulers),
      map((haulers) => {
        return haulers.map((hauler) => {
          return {
            id: hauler.haulerId,
            name: `${hauler.haulerCode.replace(/0+/, '')} ${hauler.haulerDesc}`,
          };
        });
      }),
    );
  }
}
